// From MobX documentation. useDefineForClassFields in tsconfig must be set in order to allow MobX to work with class fields.
if (!new class { x: any }().hasOwnProperty('x')) throw new Error('Transpiler is not configured correctly - required for MobX support');

export * from './utils'
export * from './list'
export * from './types'